import { useContext } from 'react'
import { AllCommentsContext } from '../../context/allComentsContext';
import { Comment } from '../../interfaces/comment';
import CommentComponent from '../commentComponent/commentComponent';
import styles from "./allCommentsComponent.module.css";
const AllCommentsComponent = () => {
  const {rootComments,getReplies} = useContext(AllCommentsContext);
  return (
    <div className={`${styles.mainContainer}`}>
        {
            rootComments.map((rootComment:Comment)=>{
                return <CommentComponent 
                email={rootComment.email}
                id={rootComment.id}
                parentId={rootComment.parentId}
                key={rootComment.id}
                commentInfo={rootComment.commentInfo} 
                createdAt={rootComment.createdAt}
                replies={getReplies(rootComment.id)}
                />
            })
        }
    </div>
  )
}

export default AllCommentsComponent;